import React from 'react';
import { CrossIcon } from 'assets/icons';
import { theme } from 'styles';
import { CrossButtonWrapper } from 'UI/Button/Button.styled';
import { Icon } from 'UI/Icon';

export interface CrossButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconColor?: string;
  hoverFill?: string;
  iconSize?: number;
}

export const CrossButton = ({
  iconColor = theme.color.grey45,
  hoverFill = theme.color.grey20,
  iconSize = 13,
  type = 'button',
  ...buttonProps
}: CrossButtonProps) => {
  return (
    <CrossButtonWrapper type={type} {...buttonProps}>
      <Icon IconComponent={CrossIcon} size={iconSize} color={iconColor} hoverFill={hoverFill} />
    </CrossButtonWrapper>
  );
};

export default CrossButton;
